/* eslint-disable */
import { useTranslation as useUiTranslation } from "react-i18next";
import { Sparkles, Check } from "lucide-react";

export default function MinimizedOrb({ progress, done, onExpand, isRTL }) {
  const { t: uiT } = useUiTranslation();
  const fillPct = Math.round(Math.min(1, progress) * 100);
  const iconTouched = progress > 0.45 || done;

  return (
    <button
      type="button"
      onClick={onExpand}
      className={`fixed z-[10000] bottom-6 ${
        isRTL ? "right-5" : "left-5"
      } w-14 h-14 rounded-full shadow-xl shadow-purple-900/25 overflow-hidden group transition-transform duration-300 hover:scale-110 active:scale-95 focus:outline-none focus:ring-2 focus:ring-[#9b59bf]/50`}
      aria-label={uiT("ui.expandGeneration")}
    >
      <style>{`
        @keyframes orbIconBob {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-2px); }
        }
      `}</style>

      <div className="absolute inset-0 bg-gray-100">
        <div
          className={`absolute inset-x-0 bottom-0 transition-[height] duration-300 ease-out ${
            done
              ? "bg-gradient-to-t from-emerald-500 to-emerald-400"
              : "bg-gradient-to-t from-[#7c3aed] to-[#9b59bf]"
          }`}
          style={{ height: `${done ? 100 : fillPct}%` }}
        />
        {!done && (
          <div
            className="absolute inset-x-0 h-2 bg-white/25 rounded-full blur-[1px]"
            style={{ bottom: `calc(${fillPct}% - 4px)` }}
          />
        )}
      </div>

      <div
        className="absolute inset-0 flex items-center justify-center"
        style={{
          animation: done ? "none" : "orbIconBob 1.6s ease-in-out infinite",
        }}
      >
        {done ? (
          <Check
            size={22}
            className="text-white drop-shadow-sm"
            strokeWidth={2.75}
          />
        ) : (
          <Sparkles
            size={20}
            className={`transition-colors duration-300 ${
              iconTouched ? "text-white" : "text-[#9b59bf]"
            }`}
          />
        )}
      </div>

      <div
        className={`absolute inset-0 rounded-full border-2 pointer-events-none ${
          done ? "border-emerald-300" : "border-white/40"
        }`}
      />
    </button>
  );
}
